import React from 'react';

export const AnnounceIcon = () => {
  return (
    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.6358 19.6752L20.9968 28.4867C21.2307 29.3596 20.7127 30.2569 19.8397 30.4908L18.3318 30.8949C17.4588 31.1288 16.5616 30.6107 16.3277 29.7378L13.9666 20.9263L18.6358 19.6752Z"
        fill="#F3F3F7"
        stroke="#444162"
        strokeWidth="1.09091"
      />
      <path
        d="M27.5105 2.43041L32.0548 19.3902C32.2887 20.2631 31.7707 21.1604 30.8978 21.3943L29.3898 21.7984C28.5169 22.0323 27.6196 21.5142 27.3857 20.6413L22.8413 3.68151C22.6074 2.80856 23.1255 1.91129 23.9984 1.67738L25.5064 1.27333C26.3793 1.03942 27.2766 1.55747 27.5105 2.43041Z"
        fill="#24D394"
        stroke="#444162"
        strokeWidth="1.09091"
      />
      <path
        d="M8.89055 19.9305L5.802 20.758C4.92905 20.9919 4.03177 20.4739 3.79787 19.601L3.08713 16.9484C2.85322 16.0755 3.37127 15.1782 4.24421 14.9443L7.33277 14.1167L8.89055 19.9305Z"
        fill="#7FB8FF"
        stroke="#444162"
        strokeWidth="1.09091"
      />
      <path
        d="M15.876 9.3741L18.6606 19.7662L10.9937 21.8205C10.1207 22.0544 9.22347 21.5363 8.98957 20.6634L7.05207 13.4326C6.81816 12.5596 7.33621 11.6623 8.20915 11.4284L15.876 9.3741Z"
        fill="#FDF2FF"
        stroke="#444162"
        strokeWidth="1.09091"
      />
      <path
        d="M15.7417 9.23668L23.0304 4.02693L27.3766 20.2474L18.4595 19.3799L15.7417 9.23668Z"
        fill="#FDF2FF"
        stroke="#444162"
        strokeWidth="1.09091"
      />
    </svg>
  );
};
